import { siteInfo } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6 p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/70">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
              <i className="ri-mail-send-fill text-xl text-accent-600"></i>
            </div>
            <div>
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                {siteInfo.contactInfo.title}
              </h2>
              <p className="text-sm text-foreground-600 mt-1">
                {siteInfo.contactInfo.subtitle}
              </p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-4 md:gap-6">
            <a
              href={`mailto:${siteInfo.contactInfo.email}`}
              className="whitespace-nowrap flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              {siteInfo.contactInfo.email}
            </a>
            <span className="whitespace-nowrap flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-qq-line"></i>
              QQ: {siteInfo.contactInfo.qq}
            </span>
            <span className="whitespace-nowrap flex items-center gap-2 text-sm text-foreground-500">
              <i className="ri-wechat-line"></i>
              微信: {siteInfo.contactInfo.wechat}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}